export default __webpack_public_path__ + "static/media/unknownCard.82eac5cc.svg";